import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";
import {getCitiesSummary, IPriceCitiesSummary} from "./get_cities_summary";

export type {IPriceCitiesSummary} from "./get_cities_summary";

export const getCitiesData = (): IPriceCitiesSummary[] => {
    const actualCitiesData = useSelector((store: IRPStore) => store.report.price.allCitiesData);
    const oldCitiesData = useSelector((store: IRPStore) => store.report.price.allCitiesDataOld);

    return getCitiesSummary(actualCitiesData, oldCitiesData);
};
import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";
import {getCitiesSummary, IPriceCitiesSummary} from "./get_cities_summary";

export type {IPriceCitiesSummary} from "./get_cities_summary";

export const getCitiesData = (): IPriceCitiesSummary[] => {
    const actualCitiesData = useSelector((store: IRPStore) => store.report.price.allCitiesData);
    const oldCitiesData = useSelector((store: IRPStore) => store.report.price.allCitiesDataOld);

    return getCitiesSummary(actualCitiesData, oldCitiesData);
};
